import { useState } from 'react'
import { Link } from 'react-router-dom'
import { toast } from 'react-toastify'
import { Row, Col, Form, Button, Spinner } from 'react-bootstrap'

import { useAuth } from '../../hooks/AuthContext'

import styles from './styles.module.css'
import { useLoading } from '../../hooks/LoadingContext'

const LoginForm = () => {
  const { signIn } = useAuth()

  const { isLoading, setIsLoading } = useLoading()
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')

  const handleSubmit = async (event) => {
    event.preventDefault()

    setIsLoading(true)
    try {
      await signIn(email, password)

      toast.info('Login realizado com sucesso!', { autoClose: 3000 })
    } catch (err) {
      if (err.message === 'Excesso de tentativas de login.') {
        toast.error('Excesso de tentativas de login. Tente novamente em alguns minutos.')
      } else {
        toast.error('Falha ao realizar o login! Verifique seus dados.')
      }
    }
    setIsLoading(false)
  }

  return (
    <Form style={{ color: '#A59E9E' }}>
      <Row style={{ marginTop: 15, textAlign: 'left' }}>
        <Col>
          <Form.Label className={styles.label}>E-mail</Form.Label>
          <Form.Control
            className={styles.infoInput}
            placeholder="Digite aqui seu e-mail"
            value={email}
            onChange={(event) => setEmail(event.target.value)}
          />
        </Col>
      </Row>
      <Row style={{ marginTop: 15, paddingBottom: 12, textAlign: 'left' }}>
        <Col>
          <Form.Label className={styles.label}>Senha</Form.Label>
          <Form.Control
            className={styles.infoInput}
            type="password"
            placeholder="Digite sua senha"
            value={password}
            onChange={(event) => setPassword(event.target.value)}
          />
        </Col>
      </Row>
      <Col style={{ textAlign: 'right' }}>
        <span>
          <Link to="/forgot-password" style={{ color: '#053C5E', fontWeight: '500' }}>
            Esqueceu sua senha?
          </Link>{' '}
        </span>
      </Col>

      <Col className="d-grid" style={{ marginTop: 15 }}>
        <Button
          className={styles.loginBtn}
          variant="primary"
          size="md"
          type="submit"
          disabled={isLoading}
          onClick={(event) => handleSubmit(event)}
        >
          {isLoading ? (
            <Spinner
              animation="border"
              size="sm"
              style={{
                color: '#fff',
                marginRight: 10,
              }}
            />
          ) : (
            'Entrar'
          )}
        </Button>
      </Col>
    </Form>
  )
}

export default LoginForm
